import React from 'react'
import { useHistory } from 'react-router-dom'
import { startCase } from 'lodash'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
// import { ClutchOriginalsDIcon } from 'components/ui-kit/Icons/svg/index'
import { ClutchOriginalsDIcon, FavouritesDIcon, LobbyDIcon } from 'components/ui-kit/Icons/svg/index'
import {
  setGameCategory,
  setProvider,
  setSearchGame,
  setTab,
  setViewFavGame
} from 'redux-thunk/redux/slices/lobby.slice'
import { setShowAllFavGames } from 'redux-thunk/redux/slices/games.slice'
import { CASINO_TABS, ROUTE_PATHS } from 'constants/index'

const GamesBar = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const history = useHistory()
  const { tab, gameCategory } = useSelector((state) => state?.lobby)
  const { casinoCategoriesList, showAllFavGames } = useSelector(
    (state) => state.games
  )
  const { loginData } = useSelector((state) => state.auth)

  return (
    <div className='casino-filter-wrap slide-wrap'>
      {/* <Slider {...casinoFilterSettings}> */}
      <button
        type='button'
        className={`btn btn-primary shadow-none ${tab === CASINO_TABS.LOBBY ? 'active' : ''
          }`}
        onClick={() => {
          history.push(ROUTE_PATHS.CASINO)
          showAllFavGames && dispatch(setShowAllFavGames(false))
          dispatch(setTab('lobby'))
          dispatch(setViewFavGame(''))
          dispatch(setProvider(''))
          dispatch(setSearchGame(''))
          dispatch(setGameCategory(''))
        }}
      >
        <LobbyDIcon />
        {t('lobby')}
      </button>
      {loginData?.accessToken && (
        <button
          type='button'
          className={`btn btn-primary shadow-none ${gameCategory === CASINO_TABS.FAVOURITE ? 'active' : ''
            }`}
          onClick={() => {
            history.push(ROUTE_PATHS.CASINO)
            dispatch(setTab(CASINO_TABS.GAME_SEARCH))
            dispatch(setShowAllFavGames(true))
          }}
        >
          <FavouritesDIcon />
          {t('favourites')}
        </button>
      )}

      <button
        type='button'
        className={`btn btn-primary ${tab === CASINO_TABS.ORIGINALS ? 'active' : ''}`}
        onClick={() => {
          history.push(ROUTE_PATHS.CASINO)
          showAllFavGames && dispatch(setShowAllFavGames(false))
          dispatch(setTab('originals'))
          dispatch(setProvider(''))
          dispatch(setSearchGame(''))
          dispatch(setGameCategory(''))
        }}
      >
        <ClutchOriginalsDIcon />
        {t('clutchOriginals')}
      </button>

      {casinoCategoriesList?.map((item) => (
        <button
          key={item?.gameCategory}
          type='button'
          className={`btn btn-primary shadow-none ${gameCategory === item?.gameCategory ? 'active' : ''
            }`}
          onClick={() => {
            history.push(`${ROUTE_PATHS.CASINO}/group/${item?.gameCategory}`)
            showAllFavGames && dispatch(setShowAllFavGames(false))
            dispatch(setTab('game-search'))
            dispatch(setGameCategory(item?.gameCategory))
            dispatch(setProvider(''))
            dispatch(setViewFavGame(''))
          }}
        >
          <img src={item?.image} alt={item.gameCategory} />
          {startCase(item?.gameCategory)}
        </button>
      ))}
      {/* </Slider> */}
    </div>
  )
}

export default React.memo(GamesBar)
